export default __webpack_public_path__ + "static/media/algo.45d65fa2.png";